/*
 * @Author: 7
 * @Date: 2023-04-24 16:44:38
 * @LastEditTime: 2023-04-25 13:21:59
 * @FilePath: /sjtu-reference-canvas/src/utils/store.js
 */

export const getParams = () => localStorage.getItem('urlParams');
export const setToken = e => localStorage.setItem('token', e);
export const getToken = () => localStorage.getItem('token');

export const search2query = search => {
  const query = {};
  if (search && search.length > 1) {
    search
      .replace('?', '')
      .split('&')
      .forEach(item => {
        let [key, ...values] = item.split('=');
        query[key] = decodeURI(values.join('=')) || true;
        // query[key] = decodeURI(values.join("=").replace(/%/g, "%25")) || true;
      });
  }
  return query;
};
